import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular';

if (environment.name !== 'development') {
  try {
    Sentry.init({
      dsn: 'https://7cd3455711ce2358c6cf8aab661c8c68@sentry.idomo.com.ar/1',
      environment: environment.name,
      integrations: [],
      tracesSampleRate: 0,
    });
  } catch (e) {
    console.error('Sentry init failed:', e);
  }
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => {
    console.error(err);
    if (environment.name !== 'development') {
      Sentry.captureException(err);
    }
  });
